import * as React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Typography } from '@/components/common';
import { CaseOverviewLinkProps } from '@/interfaces';

export const CaseOverviewLink: React.FC<CaseOverviewLinkProps> = ({
	onClick,
}) => (
	<button type="button" onClick={onClick} className="flex items-center gap-2">
		<Typography
			type="semibold-16"
			className="text-primary !text-[16px] !leading-[19.2px]"
		>
			Case Overview
		</Typography>
		<ArrowUpRight className="w-4 h-4 text-primary" />
	</button>
);
